import '@styles/blocks/acf-blocks/_lead-form-radio-switcher.scss';

function selectTab(tabs, panels, index) {
  tabs.forEach((tab, tabIndex) => {
    const isSelected = tabIndex === index;

    tab.setAttribute('aria-selected', String(isSelected));
    tab.setAttribute('tabindex', isSelected ? '0' : '-1');
    panels[tabIndex].hidden = !isSelected;
  });
}

function initSwitcher(switcher) {
  const tabs = Array.from(switcher.querySelectorAll('[data-lead-form-radio-switcher-tab]'));
  const panels = tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));

  if (!tabs.length) {
    return;
  }

  const alreadySelected = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
  selectTab(tabs, panels, alreadySelected === -1 ? 0 : alreadySelected);

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => selectTab(tabs, panels, index));

    tab.addEventListener('keydown', (event) => {
      const keyToIndex = {
        ArrowRight: (index + 1) % tabs.length,
        ArrowDown: (index + 1) % tabs.length,
        ArrowLeft: (index - 1 + tabs.length) % tabs.length,
        ArrowUp: (index - 1 + tabs.length) % tabs.length,
        Home: 0,
        End: tabs.length - 1,
      };
      const nextIndex = keyToIndex[event.key];

      if (nextIndex === undefined) {
        return;
      }

      event.preventDefault();
      selectTab(tabs, panels, nextIndex);
      tabs[nextIndex].focus();
    });
  });
}

document.querySelectorAll('[data-lead-form-radio-switcher]').forEach(initSwitcher);
